import React, { useCallback } from 'react';
import type { SubmissionDispatchers } from '@quillforms/renderer-core/build-types/types';
import { Logo } from '@urbantxt/logos';
import {
  QuillPageForm,
  ensureQuillFormsRendererRegistered,
} from '@urbantxt/form';
import serverErrorHandler from 'services/serverError.service';
import { openSuccessToaster } from 'services/toast.service';
import { addBusinessCard } from '../../api/getBusinessCardPagination';
import {
  BUSINESS_CARD_QUILL_BLOCKS,
  BUSINESS_CARD_QUILL_FORM_ID,
  BUSINESS_CARD_QUILL_MESSAGES,
  BUSINESS_CARD_QUILL_THEME,
  mapQuillAnswersToBusinessCard,
  QuillAnswersState,
} from '../../constants/businessCardQuillForm';

ensureQuillFormsRendererRegistered();

function BusinessCardForm() {
  const onSubmit = useCallback(
    async (data: object, _dispatchers: SubmissionDispatchers) => {
      const { answers } = data as { answers: QuillAnswersState };
      try {
        await addBusinessCard(mapQuillAnswersToBusinessCard(answers));
        openSuccessToaster('Business contact saved successfully.', 3000);
      } catch (error) {
        serverErrorHandler(error);
        throw error;
      }
    },
    [],
  );

  return (
    <QuillPageForm
      formId={BUSINESS_CARD_QUILL_FORM_ID}
      blocks={BUSINESS_CARD_QUILL_BLOCKS}
      theme={BUSINESS_CARD_QUILL_THEME}
      messages={BUSINESS_CARD_QUILL_MESSAGES}
      settings={{
        animationDirection: 'horizontal',
        showQuestionsNumbers: true,
        showLettersOnAnswers: false,
        disableProgressBar: false,
        disableNavigationArrows: false,
      }}
      applyLogic={false}
      onSubmit={onSubmit}
      header={<Logo />}
    />
  );
}

export default BusinessCardForm;
